//@ts-check

/**
 * Gets a translated string from the messages object
 * @param {*} messages - The messages object
 * @param {*} key - The message key to look up
 * @param {*} defaultStr - Optional default string if key not found
 * @param {*} beautify - Optional flag to beautify the result (replace underscores and capitalize)
 * @returns {string} The translated string
 */
export function getString(messages, key, defaultStr = null, beautify = null) {
  // Use nullish coalescing for cleaner fallback logic
  let result = messages[key] ?? defaultStr ?? key;

  if (beautify) {
    result = result.replaceAll("_", " ");
    return capitalizeWords(result);
  }
  return result;
}

/**
 * Capitalizes the first letter of each word in a string
 * @param {string} str - The string to capitalize
 * @returns {string} The capitalized string
 */
function capitalizeWords(str) {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
